import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import Departments from "Platform/routes/AcademicPortal/routes/Departments";
import SubjectsSetupV2 from "Platform/routes/AcademicPortal/routes/SubjectsSetupV2";
import SubjectsSetup from "Administrator/routes/AcademicSetup/routes/SubjectsSetup";
import SubjectGroupsAndSubjects from "Administrator/routes/MYPAcademicSetup/routes/SubjectGroupsAndSubjects";
import { LevelsRoute, DPSubjectsRoute } from "AppComponents/AdminNavigation";
import SubjectStandardsV2 from "Administrator/commonComponents/SubjectStandardsV2";
import AdminScopeAndSequence from "Administrator/routes/AcademicSetup/routes/AdminScopeAndSequence";
import MYPLearningStandards from "Administrator/routes/MYPAcademicSetup/routes/LearningStandards";
import DPLearningStandards from "Administrator/routes/DPAcademicSetup/routes/DPLearningStandards";
import UBDLearningStandards from "UBDAcademicSetup/routes/LearningStandards";

export default store => ({
  path: "general",
  component: withAsyncRouteLoading(() =>
    import(
      /* webpackChunkName: "general-academic-setup" */ "./components/GeneralAcademicSetup"
    ).then(module => module.default)
  ),
  childRoutes: [
    Departments(store),
    SubjectsSetupV2(store),
    SubjectsSetup(store),
    SubjectGroupsAndSubjects(store),
    LevelsRoute(store),
    DPSubjectsRoute(store),
    SubjectStandardsV2(store),
    AdminScopeAndSequence(store),
    MYPLearningStandards(store),
    DPLearningStandards(store),
    UBDLearningStandards(store),
  ],
});
